import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NuevaPasswordComponent } from './nueva-password/nueva-password.component';
import { PasswordResetComponent } from './nueva-password/password-reset.component';
import { RecoverComponent } from './recover/recover.component';


const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'passwordReset/:token', component: PasswordResetComponent },
    { path: 'passwordNew', component: NuevaPasswordComponent },
    { path: 'recover', component: RecoverComponent },
    { path: '', redirectTo: 'login', pathMatch: 'full' } // 🐱‍👤 => Cambio a Redirect para no cargar dos veces el componente
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LoginModuleRoutingModule { }
